import React, { useContext } from "react";

import { IUser } from "../../../../types";

export const UserContext = React.createContext<IUser | null>(null);

export const useUserContext = () => useContext(UserContext);
